import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useTop5 } from './hooks/useTop5';

export const Top5 = () => {
    const { values, subtitles } = useTop5();

    return (
        <SimpleBars
            title={`Total de Procedimentos (Top 5)`}
            subtitles={subtitles}
            values={values}
            horizontal
            height={400}
        />
    );
};
